export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/WishlistIcon.716ab3ed.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};